// extracted by mini-css-extract-plugin
module.exports = {"container":"Code_container__gpLwV","actions":"Code_actions__ZCzEc","copy":"Code_copy__Cmomk"};